import http from '@/http';

export default class ApiService {

	getVersao() {
		return http.get(`api/versao`).then(res => res.data);
    }

}
